import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/api/auth/auth.service';
import { OrganizacoesService } from '@app/api/organizacoes/organizacoes.service';
import { resolveOrganizacao } from '@app/shared/utils/resolve-organizacao';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

export const AuthGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const service = inject(AuthService);
  const organizacoesService = inject(OrganizacoesService);
  const rotaAtual = resolveOrganizacao(route, state);

  if (!rotaAtual) {
    return of(router.createUrlTree(['/']));
  }

  return organizacoesService.getOrganizacao(rotaAtual).pipe(
    map((organizacao) => {
      if (!organizacao) {
        return router.createUrlTree(['/']);
      }
      return service.isLogged
        ? true
        : router.createUrlTree([`/${rotaAtual}/auth/sign-up`]);
    }),
    catchError((error) => {
      console.error(error);
      return of(router.createUrlTree(['/']));
    })
  );
};
